import { useCallback, useState } from "react";
import { useAxiosMutation } from "../http/useAxiosMutation";
import { useHttp } from "../http/useHttp";
import { useDefaultError } from "@synota-io/synota-shared-ui";
import { paths } from "../generated-types";

const RESEND_INTERVAL = 10 * 1000;
type SendMfaEmailOperation = paths["/dashboard/send-mfa-email"]["get"];
type SendMfaEmailResponse = SendMfaEmailOperation["responses"][200] extends { content: unknown }
  ? unknown
  : void;

export const useMfaEmail = () => {
  const { client } = useHttp();

  const {
    mutate: _sendEmail,
    error: sendEmailError,
    submittedAt,
  } = useAxiosMutation<SendMfaEmailResponse, void>({
    mutationKey: ["send-mfa-email"],
    mutationFn: () => client.get("/send-mfa-email"),
  });

  const [canResend, setCanResend] = useState(true);

  const sendEmail = useCallback(() => {
    setCanResend(false);
    _sendEmail(undefined, {
      onSettled(_data, error) {
        if (error) {
          return setCanResend(true);
        }

        setTimeout(() => {
          setCanResend(true);
        }, RESEND_INTERVAL);
      },
    });
  }, [_sendEmail]);

  useDefaultError(sendEmailError, "There was an error trying to send the email, please try again.");

  return {
    sendEmail,
    sendEmailError,
    canResend,
    submittedAt,
  };
};
